import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "documentItem flex flex-col" }
const _hoisted_2 = { class: "text-center pb-4" }
const _hoisted_3 = { class: "text-center pb-4" }

import AImage from "@/components/Base/AImage";
import APdfThumbnail from "@/components/Base/APdfThumbnail";
import useAlert from '@/composables/useAlert';
import getLocalization from "@/utilities/get-localization";
import { getPdfUrl, getPhotoUrl } from '@/utilities/get-media-url';
import { openBaseModal } from "@/modals/modal-helper";
import { openPdfViewerModal } from '@/utilities/pdf-viewer';
import { computed } from "vue";
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentItem',
  props: {
  document: {
    type: Object,
    required: true
  }
},
  emits: ["delete"],
  setup(__props, { emit }) {

const props = __props;




const alert = useAlert();
const { t } = useI18n();

const images = computed(() => {
  const doc = props.document;
  return [doc.dokument];
});

const getType = (d: any) => {
  if (!d) {
    return undefined;
  }

  if (d.ext === '.pdf' || d.ext === '.PDF') {
    return 'pdf';
  }

  if (d.ext === 'iframe') {
    return 'iframe-url';
  }

  return 'photo';
};

const deleteDocumentAlert = (modal: any) => {
  alert.showAdv(
    t("alerts.deleteTitle"),
    t("alerts.deleteDescription"),
    [
      { text: t("alerts.deleteCancel"), },
      {
        text: t("alerts.deleteConfirm"),
        handler: () => {
          emit("delete");
          modal.dismiss();
        }
      },
    ]
  );
};

const openGallery = async () => {
  const modal = await openBaseModal('gallery', {
    images: images.value,
    title: getLocalization(props.document.name),
    downloadEnabled: true,
    onDelete: () => {
      if (modal) { 
        deleteDocumentAlert(modal)
      }
    }
  });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (getType(__props.document.dokument) === 'photo')
        ? (_openBlock(), _createBlock(_unref(AImage), {
            key: 0,
            src: _unref(getPhotoUrl)(__props.document.dokument, { thumbnail: true }),
            "image-class": 'photo object-contain rounded-lg w-full h-200',
            onClick: openGallery
          }, null, 8, ["src"]))
        : _createCommentVNode("", true),
      (getType(__props.document.dokument) === 'pdf')
        ? (_openBlock(), _createBlock(_unref(APdfThumbnail), {
            key: 1,
            id: `${__props.document.name}_${__props.document.id}`,
            url: _unref(getPdfUrl)(__props.document.dokument),
            file: __props.document,
            "image-class": 'photo object-contain rounded-lg w-full h-200',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openPdfViewerModal)(__props.document.dokument)))
          }, null, 8, ["id", "url", "file"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(getLocalization)(__props.document.name)), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getLocalization)(__props.document.beschreibung)), 1)
  ]))
}
}

})